// extracted by mini-css-extract-plugin
export default {"mainWrapper":"modal_mainWrapper__MLbsd","cross":"modal_cross__q+M4w","main_slide":"modal_main_slide__XBTW9","head":"modal_head__ki3MN"};